import React from 'react'
import {
    Button,
    Typography,
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,
} from "@material-tailwind/react";

import GalleryData from '../../models/GalleryData';


function Gallery() {

    return (
        <>
            <div className='py-10 lg:px-[5%]' >
                <Tabs value="Massage">
                    <TabsHeader>
                        {GalleryData.map(({ label, value }) => (
                            <Tab key={value} value={value}>
                                {label}
                            </Tab>
                        ))}
                    </TabsHeader>
                    <TabsBody className="grid grid-cols-1 gap-4">
                        {GalleryData.map(({ value, images }) => (
                            <TabPanel
                                className="grid grid-cols-2 gap-4 md:grid-cols-3"
                                key={value}
                                value={value}
                            >
                                {images?.map(({ imageLink }, index) => (
                                    <div key={index}>
                                        <img
                                            className="h-40  lg:h-full w-full max-w-full rounded-lg object-cover object-center"
                                            src={imageLink}
                                            alt="image-photo"
                                        />
                                    </div>
                                ))}
                            </TabPanel>
                        ))}
                    </TabsBody>
                </Tabs>
            </div>
        </>

    )
}

export default Gallery
